var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "resale_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1680 0v6851H0V0h1680z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resale_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.897 21.492l5.824 10.353a9.368 9.368 0 010 9.45c-1.648 2.951-4.648 4.696-7.943 4.696h-5.119V49l-10.18-6.02 10.18-6.078v3.01h5.119c1.707 0 2.53-1.204 2.825-1.686.294-.482.882-1.867 0-3.372l-5.825-10.353 5.12-3.01zm-30.423-1.747v12.039l-2.53-1.505-2.589 4.576c-.883 1.505-.294 2.89 0 3.372a3.167 3.167 0 002.825 1.686h11.296v6.02H9.18c-3.296 0-6.295-1.748-7.944-4.696-1.648-2.952-1.648-6.443 0-9.392l2.588-4.576-2.53-1.504 10.18-6.02zM24.479 0c3.296 0 6.295 1.748 7.943 4.696l2.588 4.576 2.531-1.505v12.039l-10.18-6.02 2.53-1.504-2.588-4.577c-.825-1.504-2.236-1.686-2.824-1.686-.532 0-1.943.182-2.825 1.686l-5.356 9.512-5.119-3.01 5.356-9.511C18.183 1.746 21.182 0 24.48 0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resale_svg__a)",
    transform: "translate(-1260 -2544)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resale_svg__b)",
    transform: "translate(1260 2544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h49v49H0V0z"
  })))));
}

export default SvgResale;